var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDraggable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #acbcbc;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230",
    transform: "translate(-110 -92)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    className: "cls-1",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(110 92)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "move",
    transform: "translate(113.506 95.506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    className: "cls-2",
    d: "M14.85,7.178,12.4,4.873a.432.432,0,0,0-.729.315V6.2H8.79V3.314H9.8a.432.432,0,0,0,.315-.729L7.808.136a.432.432,0,0,0-.63,0L4.873,2.586a.432.432,0,0,0,.315.729H6.2V6.2H3.314V5.188a.432.432,0,0,0-.729-.315L.136,7.178a.432.432,0,0,0,0,.63l2.45,2.306A.432.432,0,0,0,3.314,9.8V8.79H6.2v2.882H5.188a.432.432,0,0,0-.315.729l2.306,2.45a.432.432,0,0,0,.63,0l2.306-2.45a.432.432,0,0,0-.315-.729H8.79V8.79h2.882V9.8a.432.432,0,0,0,.729.315l2.45-2.306a.432.432,0,0,0,0-.63Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDraggable);
export default __webpack_public_path__ + "static/media/icon_draggable.79843b1f473b0ef88f0e4343b2d9e1e8.svg";
export { ForwardRef as ReactComponent };